const Web3Shim = require("./lib/web3-shim");

module.exports = {
  Web3Shim
};
